export default __webpack_public_path__ + "870b390d2ce94cd8b8e5a953a52694b4.png";